import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Storage } from "@/common/utils/storage";
import Loading from "@/components/Loading";

const STORAGE_KEY = "remember_me_enabled";

export const RememberMe: React.FC<{
  open: boolean;
  onComplete: () => void;
}> = ({ open, onComplete }: { open: boolean; onComplete: () => void }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState<"yes" | "no" | null>(null);

  const handleClick = async (value: boolean) => {
    setIsLoading(true);
    setLoadingButton(value ? "yes" : "no");
    await Storage.setItem(STORAGE_KEY, value.toString());
    onComplete();
  };

  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-lg w-[105vw] sm:w-full p-4 sm:p-6"
        showCloseButton={false}
      >
        <DialogHeader className="text-center">
          <DialogTitle className="text-xl">
            Would you like to reduce sign-ins?
          </DialogTitle>
          <DialogDescription className="text-sm mt-2">
            By selecting "Yes", you'll stay logged in for 7 days instead of the
            default 4 hours. This makes accessing Saile more convenient on your
            personal devices. Not recommended for shared or public computers.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <Button
            variant="outline"
            onClick={() => handleClick(false)}
            className="w-full sm:w-auto"
            size="sm"
            disabled={isLoading}
          >
            {loadingButton === "no" ? (
              <span className="flex items-center justify-center">
                <Loading className="h-5 w-5 mr-2" />
                <span>No, sign me out after 4 hours</span>
              </span>
            ) : (
              "No, sign me out after 4 hours"
            )}
          </Button>
          <Button
            onClick={() => handleClick(true)}
            className="w-full sm:w-auto"
            size="sm"
            disabled={isLoading}
          >
            {loadingButton === "yes" ? (
              <span className="flex items-center justify-center">
                <Loading className="h-5 w-5 mr-2" />
                <span>Yes, keep me signed in</span>
              </span>
            ) : (
              "Yes, keep me signed in"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RememberMe;
